import UiBox from "ui-box";

export const Box = UiBox;
